import React, { useEffect, useState } from 'react';
import { Tooltip } from '@chakra-ui/react';
import SheetModal from './SheetModal';
import useCurrentUser from '../../../customHook/useCurrentUser';
import { useLazyGetGoogleDriveConnectionStatusQuery } from '../../../features/apis/intergration';
import { DiGoogleDrive } from 'react-icons/di';
import axios from 'axios';

export const AUTH_URL = process.env.REACT_APP_PROD_AUTH_URL;

const ConnectGoogleDriveButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const handleCloseModal = () => setModalOpen(false);

  const user = useCurrentUser();
  const [getDriveStatus, { data }] =
    useLazyGetGoogleDriveConnectionStatusQuery();

  useEffect(() => {
    if (user?.companyId) {
      getDriveStatus(user?.companyId);
    }
  }, [getDriveStatus, user?.companyId]);

  const isGoogle = data?.isConnected;

  const handleConnectClick = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${AUTH_URL}/google/url`,

        { withCredentials: true }
      );
      // const res = await fetch(`${AUTH_URL}/google/url`);
      const result = await res.data;
      if (result.url) {
        window.open(result.url, '_blank', 'noopener,noreferrer');
      }
    } catch (err) {
      console.error('Error fetching Google auth URL', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-4 w-full">
      <Tooltip
        label={
          isGoogle
            ? 'You are already connected. Reconnecting will replace the old connection.'
            : ''
        }
        isDisabled={!isGoogle}
        placement="top"
        bg="white"
        color="black"
        borderRadius="md"
        marginLeft={5}
        fontSize="sm"
        px={3}
        maxWidth="280px"
        py={1}
      >
        <button
          type="button"
          onClick={handleConnectClick}
          className={`rounded-lg p-2 font-medium flex justify-center items-center gap-2 text-white w-full ${
            isLoading
              ? 'bg-[linear-gradient(90deg,#B79DFF,#3800D7)] opacity-60 cursor-not-allowed'
              : 'bg-[linear-gradient(90deg,#B79DFF,#3800D7)] hover:bg-[linear-gradient(90deg,#B79DFF,#3800D7)] active:bg-[linear-gradient(90deg,#B79DFF,#3800D7)] transition duration/90'
          }`}
        >
          <DiGoogleDrive />

          <span>
            {isLoading ? (
              'Connecting...'
            ) : isGoogle ? (
              <span className="pr-2">Connected</span>
            ) : (
              'Connect Drive'
            )}
          </span>
        </button>
      </Tooltip>

      <SheetModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default ConnectGoogleDriveButton;
